import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useToast } from '@chikara/ui';
import { LoginForm } from '@/features/auth/components/LoginForm'

export default function LoginPage() {
  const location = useLocation();
  const toast = useToast();

  useEffect(() => {
    if (location.state?.toast) {
      toast.success(location.state.toast);
      // Clear the state to avoid showing the toast again on refresh
      window.history.replaceState({}, document.title);
    }
  }, [location.state]);

  return <LoginForm />;
}

export { LoginPage };
